import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/auth/password/sign-up']['POST'];
type Output = ThisApi['response'];
type Input = ThisApi['body'];

const passwordSignUp = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/auth/password/sign-up', payload);
  return response.data;
};

export default passwordSignUp;
